import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Box,
  CircularProgress,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import MenuSection from "../components/MenuSection";
import venta from "../api/generarVentaQR";
import ventaAPI from "../api/venta"; // DEMO: Para emitir factura directamente
import { useNavigate } from "react-router-dom";
import cancelarVentaQR from "../api/cancelarVentaQR";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import generarFacturaJson from "../helpers/generarFacturaJson";
import { useTheme } from "@mui/material/styles";
import { setTarjetaID } from "../helpers/pagosHelper"; // Importar el helper
import ventaEfectivoQR from "../api/efectivoQR";
import { FiAlertCircle } from "react-icons/fi";
import qr from "../images/qr-shell.png";
import QRTEST from "../images/QRs/QR-TEST.png";

export const PagoQRPage = () => {
  const theme = useTheme();
  const esYPF = localStorage.getItem("bandera") === "ypf";
  const esKiosk = JSON.parse(localStorage.getItem("esKiosk")) || false;
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogSeverity, setDialogSeverity] = useState("success");
  const [dialogReintentar, setDialogReintentar] = useState(false);

  const qrImage = localStorage.getItem("urlPosicionQR");
  const posicionQR = Number(localStorage.getItem("idPosicionQR"));
  const clienteString = localStorage.getItem("cliente");
  const cliente = clienteString ? JSON.parse(clienteString) : null;
  const emiteFacturayRemito = localStorage.getItem("emiteFacturayRemito");
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  const IdEmpleadoVendedor = null; // HARDCODEADO
  const totalProductos = JSON.parse(localStorage.getItem("totalProductos"));
  var prefijo = localStorage.getItem("prefijoFront") || null;
  const navigate = useNavigate();
  const idTalonarioQR = +localStorage.getItem("idTalonarioQR");
  const conListadoQR = JSON.parse(localStorage.getItem("conListadoQR"));
  const facturaInfo = JSON.parse(localStorage.getItem("facturaInfo"));
  const [confirmCancelModalOpen, setConfirmCancelModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("confirm");
  const [isCancelDisabled, setIsCancelDisabled] = useState(
    !JSON.parse(localStorage.getItem("puedeCancelarQR")),
  ); // Estado para deshabilitar el botón Cancelar
  const [confirmCancelDialogOpen, setConfirmCancelDialogOpen] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const timerRefs = useRef([]);
  console.log(typeof isCancelDisabled);
  useEffect(() => {
    // Reemplaza la entrada actual en el historial
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  const handleBackButton = () => {
    handleCancel();
  };

  useEffect(() => {
    const obtenerIdTarjeta = async () => {
      const tarjetasData = JSON.parse(localStorage.getItem("tarjetas")); // Obtenemos el array de tarjetas
      localStorage.setItem("vengoDeQR", true);
      const idTarjeta = await setTarjetaID(null, tarjetasData);
      console.log(idTarjeta);
      generarFactura(idTarjeta);
    };

    const generarFactura = IdTarjeta => {
      const facturaJson = generarFacturaJson(
        null, // Aquí podrías pasar CuponClover si es necesario
        puesto,
        cliente,
        facturaInfo,
        totalProductos,
        prefijo,
        emiteFacturayRemito,
      );

      // Agregar campos adicionales que no estaban en el helper
      facturaJson.cabecera.IdTarjeta = IdTarjeta;
      facturaJson.cabecera.IdTerminalTarjeta = idTalonarioQR;
      facturaJson.cabecera.IdPosicionQR = posicionQR; //1 hardcodeado shellbox pago en efectivo -

      localStorage.setItem("facturaJson", JSON.stringify(facturaJson));
    };

    obtenerIdTarjeta();
  }, []);

  const handleOptionChange = event => {
    setSelectedOption(event.target.value);
  };

  const handleModalAccept = async () => {
    setConfirmCancelModalOpen(false);
    if (selectedOption === "confirm") {
      setDialogMessage("Operación confirmada con éxito");
      setIsCancelDisabled(true); // Desactiva el botón después de hacer clic
      try {
        console.log("entro hasta aca?");
        const response = await ventaEfectivoQR.efectivoQR();
        setDialogMessage(response.data.msg);
        let idsMovimientosFac = response.data.movimientos;
        localStorage.setItem(
          "idsMovimientosFac",
          JSON.stringify(idsMovimientosFac),
        );
      } catch (error) {
        console.log(error);
      }
      setDialogSeverity("success");
    } else {
      handleCancel();
    }
    setDialogOpen(true);
  };

  const generarVenta = async () => {
    try {
      // DEMO: Usar /api/venta para emitir factura directamente
      const response = await ventaAPI.postVenta(null, null, null);
      console.log("Response generarVenta (DEMO):", response);

      if (response && response?.data) {
        localStorage.setItem("pagoConQR", true);

        // Guardar facturaFinal completa (con respuestas, CAE, Prefijo, Numero)
        localStorage.setItem("facturaFinal", JSON.stringify(response.data));

        // Extraer idMovimientoFac de cada respuesta
        if (
          response.data.respuestas &&
          Array.isArray(response.data.respuestas)
        ) {
          const idsMovimientosFac = response.data.respuestas.map(
            respuesta => respuesta.idMovimientoFac,
          );
          localStorage.setItem(
            "idsMovimientosFac",
            JSON.stringify(idsMovimientosFac),
          );
        }

        setDialogMessage("El pago se procesó con éxito");
        setDialogSeverity("success");
        setDialogOpen(true);
        setLoading(false);
      } else {
        if (!isCancelled) {
          setDialogMessage("Error desconocido.");
          setDialogSeverity("error");
          setDialogOpen(true);
          setLoading(false);
        }
      }
    } catch (error) {
      // No mostrar errores si ya fue cancelado
      if (!isCancelled) {
        localStorage.setItem("vengoDeQR", false);
        console.log("Error al generar la venta:", error);
        setDialogMessage("Error al generar la venta.");
        setDialogSeverity("error");
        setDialogOpen(true);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      generarVenta();
    }, 1000);

    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  useEffect(() => {
    if (dialogOpen && dialogSeverity === "success" && !isCancelled) {
      const timer = setTimeout(() => {
        if (!isCancelled) {
          setDialogOpen(false);
          navigate(
            esYPF && esKiosk
              ? "/graciasporcomprarpage"
              : "/dialogoimprimirfacturapage",
          );
        }
      }, 3000);
      timerRefs.current.push(timer);
      return () => clearTimeout(timer);
    } else if (dialogOpen && dialogSeverity === "error" && !isCancelled) {
      const timer = setTimeout(() => {
        if (!isCancelled) {
          setDialogOpen(false);
          navigate(esYPF && esKiosk ? "/tiendakioskpage" : "/dashboard");
        }
      }, 10000);
      timerRefs.current.push(timer);
      return () => clearTimeout(timer);
    }
  }, [dialogOpen, dialogSeverity, navigate, isCancelled]);

  const clearAllTimers = () => {
    timerRefs.current.forEach(timer => clearTimeout(timer));
    timerRefs.current = [];
  };

  const handleCancelClick = () => {
    setConfirmCancelDialogOpen(true);
  };

  const handleConfirmCancel = () => {
    setConfirmCancelDialogOpen(false);
    handleCancel();
  };

  const handleCancelCancel = () => {
    setConfirmCancelDialogOpen(false);
  };

  const handleCancel = async () => {
    console.log("DEMO: Botón cancelar deshabilitado - factura ya emitida");
    return;
  };

  const handleRetry = () => {
    setDialogReintentar(false);
    generarVenta();
  };

  return (
    <>
      <MenuSection />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        {loading ? (
          <>
            <CircularProgress
              size={esKiosk ? 80 : 40}
              sx={{ color: theme.bandera.colorSecundario }}
            />
            <Typography
              variant={esKiosk ? "h3" : "h5"}
              sx={{ fontWeight: "bold", marginTop: 2 }}
            >
              Generando QR
            </Typography>
          </>
        ) : (
          <>
            <Typography
              variant={esKiosk ? "h5" : "h6"}
              sx={{
                fontWeight: "bold",
                color: "#000",
                textAlign: "center", // Centra el texto horizontalmente
                width: "100%", // Asegura que el texto ocupe todo el ancho del contenedor
                ...(esKiosk && { mt: -20 }),
              }}
            >
              {`Escanea el QR para confirmar el pago, por favor espere...`}
            </Typography>

            <CircularProgress
              sx={{ marginBottom: 1, color: theme.bandera.colorSecundario }}
            />

            {!conListadoQR && (
              <Box
                component="img"
                src={QRTEST}
                alt="QR Code"
                sx={{
                  width: esKiosk ? 400 : 250,
                  height: esKiosk ? 400 : 250,
                }}
              />
            )}

            <Typography
              variant={esKiosk ? "h5" : "h6"}
              sx={{
                fontWeight: "bold",
                marginBottom: esKiosk ? 5 : 1,
                marginTop: 1,
                color: "#000",
                textAlign: "center",
              }}
            >
              Monto: ${totalProductos.toFixed(2)}
            </Typography>

            <Button
              variant="contained"
              onClick={handleCancelClick}
              disabled={isCancelDisabled} // Deshabilita el botón después de hacer clic
              sx={{
                fontWeight: "bold",
                padding: "0.6rem",
                fontSize: esKiosk ? 20 : 16,
                whiteSpace: "nowrap",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
            >
              CANCELAR
            </Button>
          </>
        )}
      </Box>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            padding: 4,
            textAlign: "center",
            backgroundColor: theme.palette.background.default,
          }}
        >
          {dialogSeverity === "success" ? (
            <>
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: 80,
                  color: "#4caf50",
                  mb: 2,
                }}
              />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  color: "#4caf50",
                }}
              >
                ¡Éxito!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  color: "#666",
                  fontSize: "1.1rem",
                }}
              >
                {dialogMessage}
              </Typography>
              <CircularProgress
                size={40}
                sx={{
                  color: "#4caf50",
                }}
              />
            </>
          ) : (
            <>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  backgroundColor: "#fff3e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px auto",
                }}
              >
                <HighlightOffIcon
                  sx={{
                    fontSize: 50,
                    color: "#ff9800",
                  }}
                />
              </Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  color: "#333",
                }}
              >
                Algo no salió como esperábamos
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  color: "#666",
                  fontSize: "1.1rem",
                  lineHeight: 1.5,
                }}
              >
                {dialogMessage}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mb: 3,
                  color: "#999",
                  fontStyle: "italic",
                }}
              >
                Por favor, espera un momento...
              </Typography>
              <CircularProgress
                size={40}
                sx={{
                  color: theme.bandera.colorSecundario,
                }}
              />
            </>
          )}
        </Box>
      </Dialog>

      <Dialog
        open={confirmCancelModalOpen}
        onClose={() => setConfirmCancelModalOpen(false)}
      >
        <Box
          sx={{
            padding: 4,
            textAlign: "center",
            backgroundColor: theme.palette.background.default,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Confirmación de recepción para pagos electrónicos
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup value={selectedOption} onChange={handleOptionChange}>
              <FormControlLabel
                value="confirm"
                control={<Radio />}
                label="Confirmar"
              />
              <FormControlLabel
                value="cancel"
                control={<Radio />}
                label="Cancelar"
              />
            </RadioGroup>
          </FormControl>
          <Button
            variant="contained"
            onClick={handleModalAccept}
            sx={{
              mt: 2,
              backgroundColor: theme.bandera.colorSecundario,
              fontWeight: "bold",
              ":hover": {
                backgroundColor: theme.bandera.colorSecundario,
              },
            }}
          >
            ACEPTAR
          </Button>
        </Box>
      </Dialog>

      {/* Modal de confirmación para cancelar */}
      <Dialog open={confirmCancelDialogOpen} onClose={handleCancelCancel}>
        <Box
          sx={{
            padding: 4,
            textAlign: "center",
            backgroundColor: theme.palette.background.default,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
            ¿Estás seguro que deseas cancelar?
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: "#666" }}>
            Esta acción cancelará el pago en progreso.
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              variant="outlined"
              onClick={handleCancelCancel}
              sx={{
                fontWeight: "bold",
                minWidth: "120px",
              }}
            >
              NO
            </Button>
            <Button
              variant="contained"
              onClick={handleConfirmCancel}
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                fontWeight: "bold",
                minWidth: "120px",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
            >
              SÍ, CANCELAR
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={dialogReintentar}
        sx={{
          "& .MuiDialog-paper": {
            padding: theme.spacing(1),
            backgroundColor: theme.palette.background.default,
            boxShadow: theme.shadows[5],
            borderRadius: theme.shape.borderRadius,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: theme.spacing(2),
          }}
        >
          <FiAlertCircle size={48} color={theme.palette.info.main} />
        </Box>
        <DialogContent>
          <DialogContentText
            sx={{ fontSize: "1.2rem", textAlign: "inherit", width: "100%" }}
          >
            {"No se recibió el pago electrónico"} <br /> {"Intente nuevamente"}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", fontWeight: "bold" }}>
          <Button
            onClick={() => {
              setDialogReintentar(false);
              navigate("/dashboard");
            }}
            color="primary"
            variant="contained"
          >
            <Typography
              variant="body1"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Cancelar
            </Typography>
          </Button>
          <Button onClick={handleRetry} color="primary" variant="contained">
            <Typography
              variant="body1"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Reintentar
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PagoQRPage;
